import '../ServerTime'
import 'Web/Ping'
import 'Security/Module'
import './UI/UI'

/** @namespace Glonass */
NS('Glonass')

/**
 * @class
 * @extends Events
 */
Glonass.Application = Class(Events, /** @lends Glonass.Application.prototype */ {
    uiClass: 'Glonass.UI.UI',

    ui: null,
    security: null,
    configuration: {},

    initialize () {
        this.security = new Security.Security(this.createContext())
    },

    init (callback) {
        let self = this

        this.security.init(null, () => {
            if (this.uiClass) {
                self.ui = Util.create(self.uiClass)

                self.ui.init(function () {
                    if (Util.isFunction(callback)) {
                        callback.call(self)
                    }
                })
            } else {
                if (Util.isFunction(callback)) {
                    callback.call(this)
                }
            }
        })

        return this
    },

    run (callback) {
        let self = this

        Web.Ping.start()

        Web.Ping.on('failed', function () {
            alert('Вероятно, произошёл сбой в сети или выход из системы.\nПожалуйста, обновите страницу.')
        })

        ServerTime.start()

        if (this.ui) {
            this.ui.run(function () {
                if (Util.isFunction(callback)) {
                    callback.call(self)
                }
            })
        } else {
            if (Util.isFunction(callback)) {
                callback.call(this)
            }
        }

        return this
    },

    createContext () {
        return new Security.Context()
    },
    /**
     * @param {string} login
     * @param {string} password
     * @param {Object} [options]
     * @returns {Promise}
     */
    async login (login, password, options) {
        const { success, data, message } = await Promise.resolve(
            Xhr.call('login', { login, password, options }, noop, 'POST'),
        )
        assert(success, message, RequestFailedError)

        this.security.context.update(data)

        return this.security.context
    },
    /**
     * @return {Promise<null|*>}
     */
    async logout () {
        const { success, data, message } = await Promise.resolve(Xhr.call('logout'))
        assert(success, message, RequestFailedError)

        this.security.context.update(data)

        return this.security.context
    },
    /**
     * @return {Promise<void>}
     */
    async readConfiguration () {
        const { success, data } = await Promise.resolve(Xhr.call('config', null, noop))

        assert(success, 'Не удалось прочитать конфигурацию!\nПопробуйте перезагрузить страницу.', RequestFailedError)

        return data
    },
})
